import { accumulatorsReportInvalidations } from './Accumulators/Report/accumulators.report.cacheKeys'
import { useFetchAccumulatorsReport } from './Accumulators/Report/hooks/useFetchAccumulatorsReport'
import { accumulatorUserContractInvalidations } from './Accumulators/UserContracts/accumulators.contract.cacheKeys'
import { useFetchAccumulatorsUserContract } from './Accumulators/UserContracts/hooks/useFetchAccumulatorsUserContract'
import { useFetchMultiTypeAccumulatorsUserContract } from './Accumulators/UserContracts/hooks/useFetchMultiTypeAccumulatorsUserContract'
import { useCreateOperation } from './Operations/hooks/useCreateOperation'
import { useUpdateOperation } from './Operations/hooks/useUpdateOperations'

class RestCounterService {
  operations = {
    useCreateOne: useCreateOperation,
    useUpdateAll: useUpdateOperation
  }

  accumulators = {
    userContracts: {
      useFetchMultiType: useFetchMultiTypeAccumulatorsUserContract,

      useFetchContractOperations: useFetchAccumulatorsUserContract,
      invalidateContractOperations:
        accumulatorUserContractInvalidations.invalidateUserContract
    },
    report: {
      useFetchReport: useFetchAccumulatorsReport,
      invalidateReport: accumulatorsReportInvalidations.invalidateReport
    }
  }
}

export const restCounterService = new RestCounterService()
